__turbopack_context__.v({
  "controlsSlot": "listings-column-module-scss-module__AavghW__controlsSlot",
  "footerSlot": "listings-column-module-scss-module__AavghW__footerSlot",
  "header": "listings-column-module-scss-module__AavghW__header",
  "headerAction": "listings-column-module-scss-module__AavghW__headerAction",
  "headerMobileListView": "listings-column-module-scss-module__AavghW__headerMobileListView",
  "heading": "listings-column-module-scss-module__AavghW__heading",
  "headingBlock": "listings-column-module-scss-module__AavghW__headingBlock",
  "list": "listings-column-module-scss-module__AavghW__list",
  "root": "listings-column-module-scss-module__AavghW__root",
  "statsBar": "listings-column-module-scss-module__AavghW__statsBar",
  "statsBarInner": "listings-column-module-scss-module__AavghW__statsBarInner",
  "subheading": "listings-column-module-scss-module__AavghW__subheading",
});
